var DropSelectEditable = require('sma.admin/components/dropdowns/dropselecteditable')

class MultiSelectEditable extends DropSelectEditable {
	get events () {
		var events = super.events;

		events['click .dropdown-item input[type="checkbox"]'] = 'updateSelectBoxItem';

		return events;
	}

	initialize (options) {
		this.noDropdown = true;
		this.noDoneButton = true;
		this.selectedCount = true;

		super.initialize(options);
	}

	populateFromSelectBox (options) {

		var items = [];

		this.$selectEl.find('option').each(function(i, item) {
			items.push({
				name: parseInt($(item).val(), 10),
				text: $(item).text(),
				checked: $(item).is(':selected'),
			});
		});

		options.items = items;

	}

	updateSelectBoxItem (e) {
		var $checkbox = $(e.currentTarget);

		var $option = $(this.$selectEl.find(`option[value='${$checkbox.prop("name")}']`));
		$option.prop('selected', $checkbox.is(':checked'));

	}

	refreshSelectBox (datasource_items) {
		var items_checked = {}

		this.changedItems.forEach(item => {
			items_checked[item.name] = item.checked;
		})

		//refresh items from source while keeping changed values
		for (let item of datasource_items) {
			var checked = items_checked[item.name];

			if (checked){
				item.checked = true;
			}

		}

		//re-populate the select box
		this.$selectEl.empty();

		for (let item of datasource_items) {

			var option = $('<option>', {
				value: item.name,
				text: item.text,
				selected: item.checked
			});
			this.$selectEl.append(option);
		}

		return datasource_items;

	}

}

module.exports = MultiSelectEditable;

